"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectable = void 0;
var ClassLoader_1 = require("../class/ClassLoader");
/** can be inject */
function injectable() {
    return function (target) {
        if (!ClassLoader_1.classLoader.hasClass(target)) {
            ClassLoader_1.classLoader.registerClass(target);
        }
    };
}
exports.injectable = injectable;
//# sourceMappingURL=injectable.js.map